<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <header class="text-center pb-4 border-b border-grey">
      <h3
        class="my-0 font-bold"
        v-text="'Delete Document'"
      />
    </header>
    <div
      class="mt-4"
      v-text="`Are you sure you want to delete ${documentTitle}?`"
    />
    <div class="flex justify-center items-baseline modal-footer text-center mt-4">
      <button
        type="button"
        class="btn btn--danger"
        @click="deleteDocument"
        v-text="'Delete'"
      />
      <a
        href="#"
        class="mx-4"
        @click.prevent="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
export default {
  name: 'DeleteDocumentModal',
  computed: {
    documentTitle() {
      return this.document ? this.document.attributes.title : ''
    },
    documentFolderUuid() {
      return this.document ? this.document.attributes.folder_uuid : ''
    },
    show() {
      return this.$store.state.document.deleteDocumentModal.open
    },
    document() {
      return this.$store.state.document.deleteDocumentModal.document
    },
  },
  methods: {
    deleteDocument() {
      this.$api.active().delete(`documents/${this.document.uuid}`)
        .then(() => {
          this.$store.dispatch('documentGetFolderDetails', this.documentFolderUuid)

          this.$store.commit('baseAddNotification', {
            type: 'success',
            title: 'Success',
            text: 'Document deleted!',
          })

          this.close()
        })
    },
    close() {
      this.$store.commit('documentCloseDeleteDocumentModal')
    },
  },
}
</script>
